import { Product, User, Pagination } from "../types";
import Axios from "axios";
import { API_URL } from "../config/env";
import { transformProduct, transformProductOption } from "./helpers";
import { track } from "./mixpanelService";

export async function getProductByBusiness(
  id: string,
): Promise<Product[]> {
  const {
    data: { data },
  } = await Axios.get(`${API_URL}/products?business_id=${id}`);
  return data.map(transformProduct);
}

export async function listOptionProducts(
  parametar: string,
  isOffer?: boolean
) {
  if (isOffer)
    parametar = "is_offer=1&" + parametar
  const { data: { data, data_2 }, } = await Axios.get(`${API_URL}/products/filters_count?${parametar}`)
  console.log(data)
  return {
    data: data.map(transformProductOption),
    data_2: data_2
  }
}

export async function reaction(
  data: { "type": "Click" | "View", "product_id": string, twig_id?: string }) {
  await Axios.post(`${API_URL}/system_actor/reaction?`, data)
}

export async function listProducts(
  page: number = 1,
  limit: number = 10,
  parametar: string,
  isOffer?: boolean
): Promise<{
  products: Product[];
  pagination: Pagination;
}> {
  if (page == 1 && parametar != "")
    track("apply_filter")
  if (isOffer)
    parametar = "is_offer=1&" + parametar
  const {
    data: { data, paginator },
  } = await Axios.get(`${API_URL}/products?${parametar}&page=${page}&limit=${limit}`);

  return {
    products: data.map(transformProduct),
    pagination: {
      totalCount: paginator.total_count,
      totalPages: paginator.total_pages,
    }
  }
}
